import { useAuth } from '@app/core/auth/authentication/hooks/useAuth';
import {
  AodRuleReportTypeEnum,
  AodRuleTriggerEnum,
  NotificationSettingsPolicyEnum,
} from '@app/modules/audit/modules/aod/aod.types';
import { AodRuleWizard } from './AodRuleWizard';
import { AodRuleWizardValues } from './types';

export function AodCreateRuleWizard() {
  const auth = useAuth();

  const initialData: AodRuleWizardValues = {
    clientId: auth.client!.id,
    basic: {
      name: '',
      reportType: AodRuleReportTypeEnum.AUDIT_GIP_STATUS,
      trigger: AodRuleTriggerEnum.ORDER_END,
      active: true,
      notificationSettings: {
        policy: NotificationSettingsPolicyEnum.ALWAYS,
      },
      managers: [],
    },
    reportConfig: null,
    exportOptions: null,
    exportConditions: null,
  };

  return <AodRuleWizard initialData={initialData} />;
}
